module.exports = __webpack_public_path__ + "img/skygazer_logo_150.2fbb70de.png";